const messages = {
  title: "Údržba!",
  description:
    'Na serveroch práve prebiehajú nevyhnutné údržbové práce.<br/><br/>Preto je prístup k <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> momentálne nedostupný.<br/><br/>Ďakujeme za vašu trpezlivosť a pochopenie.<br/><br/> Váš tím Bridgestone',
}
export default {
  messages
}
